import { UserRound } from "lucide-react";
import { Button } from "flowbite-react";
import ClientTable from "./ClientTable";
import { ModalFrom } from "./ModalFrom";
import { useEffect, useState } from "react";
import axiosInstance from "../config/config";

export default function ClientPage() {
  const [openModal, setOpenModal] = useState(false);

  const [clients, setClients] = useState([]);

  const [e_id, setEid] = useState(0);

  const fetchClients = async () => {
    try {
      const response = await axiosInstance.post("", {
        SysID: `select * from dbo.job_client;`,
      });

      setClients(response.data || []);
      console.log("Clients loaded:", response.data);
    } catch (error) {
      console.error("Error fetching clients:", error);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  const opModal = () => {
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  return (
    <div className="h-full bg-slate-700 p-12 overflow-auto">
      {/* ←←← Your full-page content starts here */}
      <div className="flex  align-center items-center gap-2">
        <UserRound className="text-white" size={35} />
        <h1 className="text-4xl font-bold text-white">Client</h1>
      </div>
      <div className="flex">
        <Button onClick={() => setOpenModal(true)} className="ml-auto">
          + Add Client
        </Button>
      </div>
      <div className="mt-8">
        <ClientTable clis={clients} setEid={setEid} opModal={opModal} />
      </div>
      {openModal && <ModalFrom closeModal={closeModal} e_id={e_id} fetchClients={fetchClients}/>}
    </div>
  );
}
